import { createContext, useState } from "react";
import { products } from "../assets/assets";

export const ShopContext = createContext();

const ShopContextProvider = (props) => {
    const currency = '₹';
    const [cartItem, setCartItem] = useState({});

    // Function to add items to the cart with title and image
    const addToCart = (title, subId, name, price, image) => {
        let cartData = structuredClone(cartItem);

        // Update the cart structure based on title, subId, and name
        if (cartData[title]) {
            if (cartData[title][subId]) {
                if (cartData[title][subId][name]) {
                    cartData[title][subId][name].quantity += 1;
                } else {
                    cartData[title][subId][name] = { quantity: 1, price, image };
                }
            } else {
                cartData[title][subId] = { [name]: { quantity: 1, price, image } };
            }
        } else {
            cartData[title] = { [subId]: { [name]: { quantity: 1, price, image } } };
        }

        setCartItem(cartData);
    };

    // Function to remove items from the cart
    const removeFromCart = (title, subId, name) => {
        const updatedCart = { ...cartItem };

        if (updatedCart[title] && updatedCart[title][subId] && updatedCart[title][subId][name]) {
            delete updatedCart[title][subId][name];

            // Clean up empty objects
            if (Object.keys(updatedCart[title][subId]).length === 0) {
                delete updatedCart[title][subId];
            }
            if (Object.keys(updatedCart[title]).length === 0) {
                delete updatedCart[title];
            }

            setCartItem(updatedCart);
        }
    };

    // Function to update the quantity of items in the cart
    const updateItemQuantity = (title, subId, name, quantity) => {
        const updatedCart = { ...cartItem };

        if (updatedCart[title] && updatedCart[title][subId] && updatedCart[title][subId][name]) {
            if (quantity <= 0) {
                removeFromCart(title, subId, name);
            } else {
                updatedCart[title][subId][name].quantity = quantity;
                setCartItem(updatedCart);
            }
        }
    };

    const getProductCount = () => {
        let totalCount = 0;
        for (const items in cartItem) {
            for (const subId in cartItem[items]) {
                for (const productName in cartItem[items][subId]) {
                    totalCount += cartItem[items][subId][productName].quantity || 0;
                }
            }
        }
        return totalCount;
    };

    const value = {
        products,
        currency,
        cartItem,
        addToCart,
        removeFromCart,          // Newly added function
        updateItemQuantity,      // Newly added function
        getProductCount
    };

    return (
        <ShopContext.Provider value={value}>
            {props.children}
        </ShopContext.Provider>
    );
};

export default ShopContextProvider;
